import Header from '../components/layout/Header.js';
import Footer from '../components/layout/Footer.js';
import Hero from '../components/home/Hero.js';
import FeaturedTours from '../components/home/FeaturedTours.js';
import WhyChooseUs from '../components/home/WhyChooseUs.js';
import Newsletter from '../components/home/Newsletter.js';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FeaturedTours />
        <WhyChooseUs />
        <Newsletter />
      </main>
      <Footer />
    </>
  );
}